import React from 'react';
import {Route,Switch,Link}  from  'react-router-dom';
import config from '../../../assets/js/conf/config.js';
//import '../../../assets/css/common/good/details.css';
import IndexComponent from '../index/index';
import cartIndex from '../cart/index';
import myIndex from '../../user/index';
import collegeIndex from '../college/index';
import { Modal } from 'antd-mobile';


export default class HomeComponent extends React.Component{
    constructor(props){
        super(props);
        this.state={
            bHomeStyle:true,
            bCartStyle:false,
            bCollegeStyle:false,
            bMyStyle:false,
            bgStyle: false
        }
    }
    componentWillMount(){
        this.handleNavStyle(this.props)
        //console.log("调用WillMount",this.props)
        //this.props.pathname = "/home/index";
    }
    componentDidMount(){
    }
    componentWillReceiveProps(newProps){
    	//console.log(newProps)
        this.handleNavStyle(newProps)
    }
    handleNavStyle(props){
    	//console.log(props, config.path)
        switch (props.location.pathname){
            case config.path+"home/index":
            	localStorage['bottomIndex'] = 1;
                this.setState({
                    bHomeStyle:true,
                    bCartStyle:false,
                    bCollegeStyle:false,
                    bMyStyle:false
                });
                break;
            case config.path+"home/cart":
            	localStorage['bottomIndex'] = 2;
                this.setState({
                    bHomeStyle:false,
                    bCartStyle:true,
                    bCollegeStyle:false,
                    bMyStyle:false
                });
                break;
            case config.path+"home/college":
            	localStorage['bottomIndex'] = 3;
                this.setState({
                    bHomeStyle:false,
                    bCartStyle:false,
                    bCollegeStyle:true,
                    bMyStyle:false
                });
                break;
            case config.path+"home/my":
            	localStorage['bottomIndex'] = 4;
                this.setState({
                    bHomeStyle:false,
                    bCartStyle:false,
                    bCollegeStyle:false,
                    bMyStyle:true
                });
                break;
            default:
                break;
        }

    }
    componentWillUnmount(){
        this.setState=(state,callback)=>{
            return;
        }
    }
    render(){
        return(
            <div>
            	<Switch>
					<Route path={"/home/index"} component={IndexComponent} ></Route>
                    <Route path={"/home/cart"} component={cartIndex} ></Route>
                    <Route path={"/home/college"} component={collegeIndex} ></Route>
                    <Route path={"/home/my"} component={myIndex} ></Route>
                </Switch>
                <div className={'bottom-nav'}>
	                <Link to="/home/index">
	                	<ul >
	                        <li className={this.state.bHomeStyle?'home active':'home'}></li>
	                        <li className={this.state.bHomeStyle?'text active':'text'}>发现</li>
	                    </ul>
	                </Link>
	           		<Link to="/home/cart">
		           		<ul>
	                        <li className={this.state.bCartStyle?'cart active':'cart'} style={{position:'relative'}}></li>
	                        <li className={this.state.bCartStyle?'text active':'text'}>课程</li>
	                    </ul>
	           		</Link>
	           		<Link to="/home/college">
		           		<ul>
	                        <li className={this.state.bCollegeStyle?'College active':'College'}></li>
	                        <li className={this.state.bCollegeStyle?'text active':'text'}>分院</li>
	                    </ul>
	           		</Link>
	           		<Link to="/home/my">
		           		<ul>
	                        <li className={this.state.bMyStyle?'my active':'my'}></li>
	                        <li className={this.state.bMyStyle?'text active':'text'}>我的</li>
	                    </ul>
	           		 </Link>
                </div>
            </div>
        );
    }
}